import React from "react";

// Redux
import { useSelector } from "react-redux";
import { selectMenuOpen } from "../../redux/features/applicationState/applicationStateSlice";

// Helpers
import OutsideAlerter from "../../helpers/OutsideAlerter";
import { ScrollEnable } from "../../helpers/ScrollLock";

// Custom components
import { SquareXButton } from "../Buttons/Buttons";

function ImageViewModal(props) {
  const menuOpenStatus = useSelector(selectMenuOpen);

  const handleExit = () => {
    ScrollEnable();
    props.exitFunction(false);
  };

  return (
    <div
      className={`fixed z-[1] top-0 right-0 bottom-0 left-0 Xbg-red-500
                  flex flex-col items-center justify-center
                  bg-neutral-400 bg-opacity-25 backdrop-blur-sm
                  pt-12 md:pt-0
                  ${
                    menuOpenStatus
                      ? "md:pl-[6.5rem] ip11l:pl-[25.5rem]"
                      : "md:pl-[6.5rem]"
                  }
                `}
    >
      <div className="flex w-full h-full Xp-2">
        <OutsideAlerter onOutsideClick={handleExit}>
          <div className="flex flex-col items-center justify-center h-full w-full p-4 md:rounded-l-3xl bg-white">
            <div className="flex flex-row items-center justify-end w-full Xbg-green-500">
              <SquareXButton actionFunction={handleExit} />
            </div>
            <div
              className="flex flex-col w-full Xbg-red-500"
              // There is some issue with taller photos which cause elements to overflow.
              // This offset fixes the issue, while making sure that shorter photos look normal.
              style={{ height: "calc(100% - 2rem)" }}
            >
              {props.children}
            </div>
          </div>
        </OutsideAlerter>
      </div>
    </div>
  );
}

export default ImageViewModal;
